// extracted by mini-css-extract-plugin
module.exports = {"SavedIndicator":"_2DV1MXxo","text":"_32HfXJIe"};